@if (remainingMatches.length === 0) {
    <!-- mimic the dx accordion markup so that results without the caret line up correctly -->
    <div class="dx-accordion d-flex flex-grow-1">
        <div class="dx-accordion-item-title dx-accordion-item-title-no-caret mb-0 flex-grow-1">
            <ng-container *ngTemplateOutlet="itemRow"></ng-container>
        </div>
    </div>
}

@if (remainingMatches.length > 0) {
    <dx-accordion [dataSource]="[result]"
                  itemTemplate="detail"
                  [collapsible]="true"
                  [multiple]="true"
                  [selectedItems]="[]"
                  keyExpr="ItemId"
                  (onInitialized)="accordionInitialised($event)">
        <div *dxTemplate="let result of 'title'"
             class="d-flex">
            <ng-container *ngTemplateOutlet="itemRow"></ng-container>
        </div>
        <div *dxTemplate="let result of 'detail'"
             class="py-1 px-0">
            @for (match of remainingMatches; track match) {
                <div class="row d-flex pt-1 align-items-center">
                    <div class="col">
                        <ng-container *ngTemplateOutlet="crumbTemplate || crumbs; context: { match: match }"></ng-container>
                    </div>
                    <div class="col-auto snippet text-muted text-end">
                        <ng-container
                                      *ngTemplateOutlet="snippetTemplate || defaultSnippetTemplate; context: { match: match }"></ng-container>
                    </div>
                </div>
            }
        </div>
    </dx-accordion>
}

<ng-template #itemRow>
    @if (getRouterLink(href$ | async); as link) {
        @if (!openInNewTab) {
            <a class="d-flex flex-grow-1 flex-wrap align-content-center search-result-row"
               [ngClass]="{ 'no-matches': remainingMatches.length === 0 }"
               [routerLink]="link.path"
               [queryParams]="link.queryParams">
                <ng-container *ngTemplateOutlet="itemRowContent"></ng-container>
            </a>
        } @else {
            <a class="d-flex flex-grow-1 flex-wrap align-content-center search-result-row"
               target="_blank"
               [ngClass]="{ 'no-matches': remainingMatches.length === 0 }"
               [href]="href$ | async">
                <ng-container *ngTemplateOutlet="itemRowContent"></ng-container>
            </a>
        }
    } @else {
        <a class="d-flex flex-grow-1 flex-wrap align-content-center search-result-row"
           target="_blank"
           [ngClass]="{ 'no-matches': remainingMatches.length === 0 }"
           [href]="href$ | async">
            <ng-container *ngTemplateOutlet="itemRowContent"></ng-container>
        </a>
    }

    <ng-template #newTabLink>
        <a class="d-flex flex-grow-1 flex-wrap align-content-center search-result-row"
           target="_blank"
           [ngClass]="{ 'no-matches': remainingMatches.length === 0 }"
           [href]="href$ | async">
            <ng-container *ngTemplateOutlet="itemRowContent"></ng-container>
        </a>
    </ng-template>

    <ng-template #itemRowContent>
        <ng-content></ng-content>

        @if (firstMatch; as match) {
            <div class="d-flex flex-column flex-grow-1 align-items-end justify-content-center flex-wrap snippet text-muted">
                @if (showFirstCrumb) {
                    <div>
                        <ng-container *ngTemplateOutlet="crumbTemplate || crumbs; context: { match: match }"></ng-container>
                    </div>
                }
                <div>
                    <ng-container *ngTemplateOutlet="snippetTemplate || defaultSnippetTemplate; context: { match: match }"></ng-container>
                </div>
            </div>
        }
    </ng-template>
</ng-template>

<ng-template #defaultSnippetTemplate
             let-match="match">
    @if (match.snippet) {
        <em class="flex-basis-100 ms-1">
            <!-- need them spaced like this so there isn't any spacing between the quotes -->
            &ldquo;<adapt-highlighted-text [needle]="keyword"
                                    [haystack]="match.snippet"></adapt-highlighted-text>&rdquo;</em>
    }
</ng-template>

<ng-template #crumbs
             let-matched="match">
    @if (asMatch(matched); as match) {
        @for (crumb of match.field; track crumb; let last = $last) {
            <span>{{ crumb }}</span>
            @if (!last) {
                <span class="px-1">&gt;</span>
            }
        }
    }
</ng-template>
